import { graphql } from '@/utils/graphql';
import { logger } from '@/utils/logger';
import type { BedrockMessage } from '@/utils/beemAgentTypes';

const ns = 'app.services.conversationFolderName';

// A question cut to a few words at a word boundary, when the model cannot name it.
const fallback = (question: string) => {
  const text = question.replace(/\s+/g, ' ').trim().replace(/[?.!]+$/, '');
  if (text.length <= 40) return text || 'Conversation';
  return `${text.slice(0, 40).replace(/\s+\S*$/, '')}…`;
};

/**
 * A short name (a few words) for the folder that holds what the AI Assistant created in a
 * conversation, from the conversation's title, which is its whole first question.
 */
export async function conversationFolderName(question: string): Promise<string> {
  if (!question.trim()) return 'Conversation';
  try {
    const prompt = `Name this conversation in 2 to 5 words, as a folder name: a noun phrase in the language of the question, sentence case, no quotes, no trailing punctuation. Reply with ONLY the name.\n\nQuestion: "${question.slice(0, 500)}"`;
    const { messages } = await graphql('beemAgentInsightConverse', {
      query: { datasets: '[]', prompt, messages: '[]', reasoning: false },
    });
    const parsed: BedrockMessage[] = JSON.parse(messages);
    const last = parsed[parsed.length - 1];
    const name = last?.role === 'assistant' ? last.content?.[0]?.text?.trim() : undefined;
    const clean = name?.replace(/^["'«]|["'»]$/g, '').replace(/[.!?]+$/, '').trim();
    return clean && clean.length <= 60 ? clean : fallback(question);
  } catch (e) {
    logger.debug({ label: `${ns}.error`, message: e });
    return fallback(question);
  }
}
